"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlatButtonLink = exports.FlatButton = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
/**
 * Note that this uses a border style that matches
 * the color of the button itself. This is so that
 * it will be the same size as the secondary button.
 */
exports.FlatButton = styled_1.default.button `
  cursor: pointer;
  background-color: transparent;
  color: ${(0, ui_theme_1.fromTheme)('color_button_contrast')};
  border: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')} transparent;
  border-radius: ${(0, ui_theme_1.fromTheme)('border_radius')};
  font-family: ${(0, ui_theme_1.fromTheme)('font_face')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
  padding: ${(0, ui_theme_1.fromTheme)('spacing_small')} ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  text-decoration: none;
  display: inline-block;
  &:focus {
    outline: none;
  }
  &:focus,
  &:hover {
    background-color: ${(0, ui_theme_1.fromTheme)('color_button_flat_hover')};
    border-color: ${(0, ui_theme_1.fromTheme)('color_button_flat_hover')};
  }
  &:disabled {
    cursor: not-allowed;
    color: ${(0, ui_theme_1.fromTheme)('color_text_button_disabled')};
    background-color: transparent;
    border-color: transparent;
  }
`;
exports.FlatButtonLink = (0, styled_1.default)((props) => (react_1.default.createElement(exports.FlatButton, Object.assign({ as: "a" }, props)))) ``;
//# sourceMappingURL=flat.js.map